import { render, staticRenderFns } from "./DynamicContentTable.vue?vue&type=template&id=3e4b0dc0"
import script from "./DynamicContentTable.vue?vue&type=script&lang=js"
export * from "./DynamicContentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports